import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Section, StatCard, IconButton } from '../../shared/components';
import { useCurrentUser, useSignOut } from '../../shared/auth/AuthProvider';
import { TimerIcon, SettingsIcon, LogoutIcon, TrendIcon } from '../../shared/icons';

/**
 * Home de Gestion Humana - FASE 1 (este entregable): confirma que se entro
 * correctamente a esta aplicacion con el Rol resuelto para ella. "Horas
 * Extra" (el desarrollo real, ver Documentacion_Macros_CALCULO_TIEMPO_EXTRA.md)
 * se agrega en la siguiente fase - por ahora es un aviso "Próximamente".
 */
export function HrHomePage() {
  const navigate = useNavigate();
  const user = useCurrentUser();
  const signOut = useSignOut();

  const greeting = useMemo(() => {
    const h = new Date().getHours();
    if (h < 12) return 'Buenos días';
    if (h < 19) return 'Buenas tardes';
    return 'Buenas noches';
  }, []);

  return (
    <div>
      <div className="safe-top flex items-start justify-between px-4 pb-2 pt-5">
        <div>
          <p className="text-sm text-ink-400">{greeting},</p>
          <h1 className="text-2xl font-bold text-ink-900">{user.fullName.split(' ')[0]}</h1>
        </div>
        {signOut && (
          <IconButton
            icon={<LogoutIcon width={20} height={20} />}
            label="Cerrar sesión"
            onClick={signOut}
            className="h-11 w-11 text-ink-400 hover:bg-ink-100 hover:text-critical"
          />
        )}
      </div>

      <div className="p-4">
        <Section title="Gestión Humana">
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
            <StatCard icon={<TimerIcon />} label="Extra, recargos y festivos" value="Horas Extra" tone="brand" onClick={() => navigate('/gestion-humana/horas-extra')} />
            <StatCard icon={<TrendIcon />} label="Ingresos, gastos y utilidad por cliente" value="Resultados Financieros" tone="info" onClick={() => navigate('/gestion-humana/resultados')} />
            {user.role === 'admin' && <StatCard icon={<SettingsIcon />} label="Usuarios y roles" value="Configuración" tone="info" onClick={() => navigate('/gestion-humana/configuracion')} />}
          </div>
        </Section>
      </div>
    </div>
  );
}
